import api from './api';

export interface BindEmailResponse {
  success: boolean;
  data?: {
    message: string;
  };
  error?: {
    message: string;
  };
}

export async function bindEmail(email: string): Promise<BindEmailResponse> {
  return api.post('/api/members/me/bind-email', { email });
}

export interface LineProfile {
  lineUserId: string;
  displayName: string;
  pictureUrl?: string;
}

export interface LineProfileResponse {
  success: boolean;
  data?: {
    isLinked: boolean;
    lineUserId?: string;
    displayName?: string;
    pictureUrl?: string;
  };
}

export async function getLineProfile(): Promise<LineProfileResponse> {
  return api.get('/api/line/profile');
}

export async function linkLineAccount(code: string, state: string) {
  return api.post('/api/line/link', { code, state });
}

export async function unlinkLineAccount() {
  return api.delete('/api/line/link');
}

export interface NotificationPreferences {
  emailEnabled: boolean;
  weeklyDigest: boolean;
  newMatchAlert: boolean;
  wishContactedAlert: boolean;
  systemAnnouncements: boolean;
}

export async function getNotificationPreferences(): Promise<{ success: boolean; data?: NotificationPreferences }> {
  return api.get('/api/members/me/notification-preferences');
}

export async function updateNotificationPreferences(prefs: Partial<NotificationPreferences>) {
  return api.put('/api/members/me/notification-preferences', prefs);
}
